export default __webpack_public_path__ + "static/media/bijay-D.33186556.png";